"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolTypeEnum = void 0;
var SymbolTypeEnum;
(function (SymbolTypeEnum) {
    SymbolTypeEnum["ADR"] = "ad";
    SymbolTypeEnum["REIT"] = "re";
    SymbolTypeEnum["ClosedEndFund"] = "ce";
    SymbolTypeEnum["SecondaryIssue"] = "si";
    SymbolTypeEnum["LimitedPartnerships"] = "lp";
    SymbolTypeEnum["CommonStock"] = "cs";
    SymbolTypeEnum["ETF"] = "et";
    SymbolTypeEnum["ETC"] = "etc";
    SymbolTypeEnum["Warrant"] = "wt";
    SymbolTypeEnum["OpenEndedFund"] = "oef";
    SymbolTypeEnum["ClosedEndedFund"] = "cef";
    SymbolTypeEnum["MutualFund"] = "mf";
    SymbolTypeEnum["PreferredStock"] = "ps";
    SymbolTypeEnum["CryptoCurrency"] = "ct";
    SymbolTypeEnum["Futures"] = "futures";
    SymbolTypeEnum["Commodity"] = "commodity";
    SymbolTypeEnum["Bond"] = "bond";
    SymbolTypeEnum["Index"] = "index";
    SymbolTypeEnum["Note"] = "note";
    SymbolTypeEnum["Other"] = "ot";
})(SymbolTypeEnum = exports.SymbolTypeEnum || (exports.SymbolTypeEnum = {}));
//# sourceMappingURL=symbol-type-enum.js.map